/*********************** Custom JS for Boost AI Search & Discovery  ************************/
//if (window.boostSDAppConfig) {
//window.boostSDAppConfig.integration =  Object.assign({
//wishlists: 'king'
//}, window.boostSDAppConfig.integration || {});
// }
console.log('boost custom')
if(boostSDAppConfig?.filterSettings) {
  boostSDAppConfig.filterSettings.filterLayout = 'horizontal';
}
const sampleCustomization = {
  updateProductItemGrid: (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductItem", {
      name: "Add extra information",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          
       
          // This function runs after the product item is rendered on the page
          try {
            // Start customization--------------------------------------------
            let productData = element.getParams().props.product; // Get product data
              
            let productId = productData.id;
            if (productData?.split_product) {
              productId = productData.variant_id;
            }
            let productItem = document.querySelector(
              '[data-product-id="' + productId + '"]'
            ); // Get the product item element
            
            if (!productItem) {
              console.error("Product item not found for product ID:", productId);
              return;
            }
            if(!productItem.querySelector('.badge-usp'))
              {
                for (var i = productData.tags.length - 1; i >= 0; i--) {
                  tag = productData.tags[i];
                   if (tag.indexOf("plp-badge-") !== -1) {
                    //add badges 
            const badgeHTML = `
            <div class="badge-usp">
              <div class="">${tag.split('plp-badge-')[1]}</div>
            </div>`;
                    var preTagLabel = '<span class="display-tag display-tag-small display-tag-gender">'+tag.split('plp-badge-')[1]+'</span>';
                    productItem
                    .querySelector(".boost-sd__product-image")
                    .insertAdjacentHTML("beforeend", badgeHTML);
                    
                   }
                }
              }
            
          
            var activeProductColor = "";
            if (!productItem.querySelector(".colorSwatch")) {
                 const colorSwatch = `
                    <style>
                      
                    </style>
                    <div style="display: flex; flex-direction: column;">
                      <div class="colorSwatch"></div>
                    </div>`;
                  productItem
                    .querySelector(".boost-sd__product-image")
                    .insertAdjacentHTML("afterend", colorSwatch);
              
              productData.metafields.forEach((metaObject) => {
               
                //UK Badge
                if (metaObject.key == "badge" && window.strings.collectionBadges == "true" && Shopify.country == "GB") {     
                  const priceDiv = productItem.querySelector(".boost-sd__product-price");
                  const badgeDiv = document.createElement("div");
                  badgeDiv.classList.add("badge");
                  badgeDiv.innerHTML = metaObject.value;
                  priceDiv.insertAdjacentElement("afterend", badgeDiv);
                }
                else if(metaObject.key == "badge_us" && window.strings.collectionBadges == "true" && Shopify.country == "US")
                {
                  const priceDiv = productItem.querySelector(".boost-sd__product-price");
                  const badgeDiv = document.createElement("div");
                  badgeDiv.classList.add("badge");
                  badgeDiv.innerHTML = metaObject.value;
                  priceDiv.insertAdjacentElement("afterend", badgeDiv);
                }
                if (metaObject.key == "linked_products") {
                  
                  
                  var color = null;
                  var focalPoint = null;
                  var image = null;                 
                  const metaObjectValue = metaObject.value;
                  
                  
                  function findLinkedProducts() {
                    fetch(window.Shopify.routes.root + "api/graphql", {
                      method: "POST",
                      headers: {
                        "X-Shopify-Storefront-Access-Token":
                          "b71b026299672643621edd5c999cff3a",
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify({
                        query: `{
                          metaobject(id: "${metaObjectValue}") {
                            field(key: "linked_products") {
                              value
                            }
                          }
                        }`,
                      }),
                    })
                      .then((response) => {
                        if (!response.ok) {
                          throw new Error("Network response was not ok");
                        }
                        return response.json();
                      })
                      .then((data) => {
                        
                        const products =
                          data.data.metaobject.field.value.split(",");
                          console.log(products, "products")
                        var query = products
                          .map((product) => {
                            var output = product.split("/");
                            var lastElement = output[output.length - 1];
                            return lastElement.slice(0, -2);
                          })
                          .join(" OR ");
                          console.log(query, "query");
                        return fetch(window.Shopify.routes.root + "api/graphql", {
                          method: "POST",
                          headers: {
                            "X-Shopify-Storefront-Access-Token":
                              "b71b026299672643621edd5c999cff3a",
                            "Content-Type": "application/json",
                          },
                          body: JSON.stringify({
                            query: `{
                              products(first: 50, query: "${query}") {
                                edges {
                                  node {
                                    id
                                    title
                                    onlineStoreUrl
                                    availableForSale
                                    featuredImage {
                                      url
                                    }
                                    metafields(identifiers: [
                                      { namespace: "custom", key: "color" },
                                      { namespace: "custom", key: "colorswatchurl" }
                                    ]) {
                                      reference {
                                        ... on MediaImage {
                                          presentation {
                                            asJson(format: IMAGE)
                                          }
                                          image {
                                            url
                                            height
                                            width
                                          }
                                        }
                                      }
                                      value
                                    }
                                  }
                                }
                              }
                            }`,
                          }),
                        });
                      })
                      .then((response) => {
                        if (!response.ok) {
                          throw new Error("Network response was not ok");
                        }
                        return response.json();
                      })
                      .then((data) => {
                        console.log(data);
                        var productMetafields = data.data.products.edges;
                        var total = data.data.products.edges.length;
                        var count = 0
                        var added =false
                        productMetafields.forEach((productMetafield) => {
                          if(productMetafield.node.availableForSale != false){
                          if(count == 5){
                              var extra = total - count;
                              if(extra > 0 && added == false){
                                added = true;
                                  productItem
                              .querySelector(".colorSwatch")
                              .insertAdjacentHTML("beforeend", `<div style="display: flex;height: 30px;align-items: center;">+ ${extra}</div>`);
                              }
                            
                            return;
                          }
                          
                          
                          image = productMetafield.node.featuredImage.url;
                          var metafields = productMetafield.node.metafields;
                          if (metafields[1] && metafields[1].reference && metafields[1].reference.presentation) {
                            focalPoint = metafields[1].reference.presentation.asJson.focalPoint;                           
                            var generateImageURL =
                              metafields[1].reference.image.url.substring(0, metafields[1].reference.image.url.lastIndexOf("?")) +
                              "?crop=region&crop_height=100&crop_left=" +
                              Math.ceil(focalPoint.x * metafields[1].reference.image.width) +
                              "&crop_top=" +
                              Math.ceil(focalPoint.y * metafields[1].reference.image.height) +
                              "&crop_width=100&height=40&v=1709648334&width=40";
                            var span = `<a href="${productMetafield.node.onlineStoreUrl}"><span class="dot" style="background-image: url(${generateImageURL}); background-position-x: ${focalPoint.x}; background-position-y:${focalPoint.y}; --focus-x:${focalPoint.x}; --focus-y:${focalPoint.y};"></span></a>`;
                            productItem
                              .querySelector(".colorSwatch")
                              .insertAdjacentHTML("beforeend", span);
                          } else if (metafields[0]) {
                            color = metafields[0].value;
                            var span = `<a href="${productMetafield.node.onlineStoreUrl}"><span class="dot" style="background-color: ${color.toString()};"></span></a>`;
                            productItem
                              .querySelector(".colorSwatch")
                              .insertAdjacentHTML("beforeend", span);
                          } else if (metafields[1] && metafields[1].reference ) {                         
                            var span = `<a href="${productMetafield.node.onlineStoreUrl}"><span class="dot" style="background-image: url('${metafields[1].reference.image.url}');     background-size: 100%;
                            background-position: center;"></span></a>`;
                            productItem
                              .querySelector(".colorSwatch")
                              .insertAdjacentHTML("beforeend", span);
                          } else
                          {
                            console.warn("Metafields do not contain the expected properties:", metafields);
                            
                          }
                          count++;
                         
                          }
                        });
                      }).then(() => {
                        // SAM - have added the below in manually for now, 
                        // Women's Cricket Style Cable V Neck Jumper - 
                        // Cream & Black metafields are not being returned above
                        if(productId == "8468930232601" || productId == "8468930953497"){
                          var span = `<a href="/products/womens-cricket-style-cable-v-neck-jumper-cream-black"><span class="dot" style="background-image: url('https://cdn.shopify.com/s/files/1/0784/1388/9817/files/Screenshot_2024-06-06_at_15.06.55_dc577805-3263-446d-8001-b8391a5651da.png?v=1718171473');     background-size: 100%;
                          background-position: center;"></span></a>`;
                          productItem
                            .querySelector(".colorSwatch")
                            .insertAdjacentHTML("beforeend", span);
                        }
                        
                        
                      })
                      .catch((error) => {
                        console.error("There was an error:", error);
                      });
                  }
               
                  findLinkedProducts();
                }
              });
            }
            // End-------------------------------------------------------------
          } catch (e) {
            console.warn(e);
          }
        },
      }),
    });
  },
};
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  sampleCustomization.updateProductItemGrid,
]);